webpackJsonp([1],{

/***/ 16:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return submitData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setPoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setSprintName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return newSprint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sprintById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_revue__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_revue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_revue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_duck__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_duck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_duck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__localStorage__ = __webpack_require__(257);




var _duck$createReducer;








var duck = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_duck__["createDuck"])('root', 'burn-it-down');

var SUBMIT_DATA = duck.defineType('SUBMIT_DATA');
var SET_POINTS = duck.defineType('SET_POINTS');
var SET_SPRINT_NAME = duck.defineType('SET_SPRINT_NAME');
var NEW_SPRINT = duck.defineType('NEW_SPRINT');
var SPRINT_BY_ID = duck.defineType('SPRINT_BY_ID');

var submitData = duck.createAction(SUBMIT_DATA);
var setPoints = duck.createAction(SET_POINTS);
var setSprintName = duck.createAction(SET_SPRINT_NAME);
var newSprint = duck.createAction(NEW_SPRINT);
var sprintById = duck.createAction(SPRINT_BY_ID);

var initialState = {
  sprints: {},
  id: '',
  name: '',
  days: 0,
  points: 0,
  optimal: [],
  remaining: [],
  realized: []
};

var generateId = function generateId() {
  return Math.random().toString(36).substring(5);
};

var reducer = duck.createReducer((_duck$createReducer = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_duck$createReducer, SUBMIT_DATA, function (state, _ref) {
  var payload = _ref.payload;
  var days = payload.days;
  var points = payload.points;

  var base = new Array(days).fill(0);
  var optimalPoints = points;
  var pointsPerDay = points / days;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state, {
    id: generateId(),
    days: days,
    points: points,
    pointsPerDay: pointsPerDay,
    optimal: base.reduce(function (optimal) {
      optimalPoints -= pointsPerDay;
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(optimal), [optimalPoints]);
    }, [points]),
    remaining: base.reduce(function (remaining) {
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(remaining), [points]);
    }, [points]),
    realized: base
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_duck$createReducer, SET_POINTS, function (state, _ref2) {
  var payload = _ref2.payload;
  var day = payload.day,
      points = payload.points;
  var remaining = state.remaining,
      realized = state.realized;

  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state, {
    remaining: remaining.map(function (value, index) {
      return index > day ? value - points : value;
    }),
    realized: realized.map(function (value, index) {
      return index === day ? value + points : value;
    })
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_duck$createReducer, SET_SPRINT_NAME, function (state, _ref3) {
  var payload = _ref3.payload;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state, {
    name: payload
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_duck$createReducer, NEW_SPRINT, function (state) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, initialState, {
    sprints: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.sprints, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, state.id, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["omit"])(state, 'sprints')))
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_duck$createReducer, SPRINT_BY_ID, function (state, _ref4) {
  var payload = _ref4.payload;

  if (state.sprints[payload]) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
      sprints: state.sprints
    }, state.sprints[payload]);
  }
  return state;
}), _duck$createReducer), initialState);

var persistedState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__localStorage__["a" /* loadState */])();

var reduxStore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux__["a" /* createStore */])(reducer, persistedState, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());


reduxStore.subscribe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["throttle"])(function () {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__localStorage__["b" /* saveState */])(reduxStore.getState());
}, 1000));

var store = new __WEBPACK_IMPORTED_MODULE_4_revue___default.a(__WEBPACK_IMPORTED_MODULE_3_vue__["default"], reduxStore);

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(363)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(548),
  /* scopeId */
  "data-v-8624c526",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(362)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(547),
  /* scopeId */
  "data-v-5f079175",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Sprint__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Sprint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Sprint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Sprints__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Sprints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Sprints__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
  }, {
    path: '/sprint/:id',
    name: 'Sprint',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Sprint___default.a
  }, {
    path: '/sprints',
    name: 'Sprints',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Sprints___default.a
  }]
}));

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(359)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(544),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Line"].extend({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp],
  props: ['chartData'],
  mounted: function mounted() {
    this.renderChart(this.chartData, {
      elements: {
        point: {
          radius: 0
        },
        line: {
          tension: 0
        }
      }
    });
  }
}));

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(253);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return saveState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var loadState = function loadState() {
  try {
    var serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

var saveState = function saveState(state) {
  try {
    var serializedState = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state);
    localStorage.setItem('state', serializedState);
  } catch (err) {
    throw err;
  }
};

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_LinkTo__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_LinkTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_LinkTo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(16);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'form',
  data: function data() {
    return {
      days: '',
      points: '',
      errors: {},
      id: this.$select('id')
    };
  },

  methods: {
    submitData: function submitData(e) {
      e.preventDefault();
      if (this.days && this.points) {
        __WEBPACK_IMPORTED_MODULE_1__state__["a" /* store */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__state__["f" /* submitData */])({
          days: parseInt(this.days, 10),
          points: parseInt(this.points, 10)
        }));
        console.log();
        this.$router.push('sprint/' + this.id);
      } else {
        this.errors.days = !this.days;
        this.errors.points = !this.points;
      }
    }
  },
  components: { LinkTo: __WEBPACK_IMPORTED_MODULE_0__ui_LinkTo___default.a }
});

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_ActionButton__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_ActionButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_ActionButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(16);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chart-done',
  data: function data() {
    return {
      realized: this.$select('realized')
    };
  },

  computed: {
    isDone: function isDone() {
      return !__WEBPACK_IMPORTED_MODULE_0_lodash_includes___default()(this.realized, 0);
    }
  },
  methods: {
    newSprint: function newSprint() {
      this.$router.push('/');
      __WEBPACK_IMPORTED_MODULE_2__state__["a" /* store */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__state__["e" /* newSprint */])());
    },
    showStats: function showStats() {
      console.log('Show Stats!');
    }
  },
  components: { ActionButton: __WEBPACK_IMPORTED_MODULE_1__ui_ActionButton___default.a }
});

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_TextInput__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(16);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chart-form',
  data: function data() {
    return {
      day: 0,
      optimal: this.$select('optimal'),
      points: null
    };
  },

  computed: {
    days: function days() {
      return this.optimal.map(function (o, index) {
        return index;
      }).slice(0, this.optimal.length - 1);
    }
  },
  methods: {
    submitData: function submitData(e) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_1__state__["a" /* store */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__state__["c" /* setPoints */])({
        day: parseInt(this.day, 10),
        points: parseInt(this.points, 10) || 0
      }));
      if (this.day < this.optimal.length - 2) {
        this.day = this.day + 1;
      }
      this.points = null;
    }
  },
  components: { TextInput: __WEBPACK_IMPORTED_MODULE_0__ui_TextInput___default.a }
});

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chart-list',
  data: function data() {
    return {
      realized: this.$select('realized'),
      remaining: this.$select('remaining')
    };
  }
});

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_TextInput__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(16);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chart-name',
  data: function data() {
    return {
      name: this.$select('name')
    };
  },

  methods: {
    nameChanged: function nameChanged(name) {
      __WEBPACK_IMPORTED_MODULE_1__state__["a" /* store */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__state__["d" /* setSprintName */])(name));
    }
  },
  components: { TextInput: __WEBPACK_IMPORTED_MODULE_0__ui_TextInput___default.a }
});

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chart-score',
  data: function data() {
    return {
      pointsPerDay: this.$select('pointsPerDay'),
      realized: this.$select('realized')
    };
  },

  computed: {
    score: function score() {
      var sum = 0;
      this.realized.forEach(function (r) {
        sum += r;
      });
      return sum / this.realized.length;
    },
    health: function health() {
      var realized = this.realized.filter(function (r) {
        return r;
      });
      var sum = 0;
      realized.forEach(function (r) {
        sum += r;
      });
      if (!sum || !realized.length) return 'poor';
      var health = sum / realized.length;

      var poor = this.pointsPerDay * 0.3;
      var bad = this.pointsPerDay * 0.5;
      var okay = this.pointsPerDay * 0.7;
      var good = this.pointsPerDay * 0.9;

      if (health <= poor) {
        return 'poor';
      } else if (health <= bad && health > poor) {
        return 'bad';
      } else if (health <= okay && health > bad) {
        return 'okay';
      } else if (health <= good && health > okay) {
        return 'good';
      }
      return 'excelent';
    }
  }
});

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Burndown__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SprintDone__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SprintDone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SprintDone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SprintScore__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SprintScore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SprintScore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SprintName__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SprintName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SprintName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SprintForm__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SprintForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SprintForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SprintList__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SprintList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SprintList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state__ = __webpack_require__(16);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chart',
  beforeMount: function beforeMount() {
    var sprintId = this.$router.currentRoute.params.id;
    __WEBPACK_IMPORTED_MODULE_6__state__["a" /* store */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__state__["b" /* sprintById */])(sprintId));

    if (this.optimal && !this.optimal.length || this.remaining && !this.remaining.length || this.realized && !this.realized.length) {
      this.$router.push('/');
    }
  },
  data: function data() {
    return {
      optimal: this.$select('optimal'),
      remaining: this.$select('remaining'),
      realized: this.$select('realized')
    };
  },

  computed: {
    chartData: function chartData() {
      return {
        labels: this.optimal.map(function (o, index) {
          return 'Day ' + (index + 1);
        }),
        datasets: [{
          label: 'Optimal',
          data: this.optimal,
          borderColor: '#3F51B5',
          backgroundColor: '#3F51B5',
          fill: false
        }, {
          label: 'Remaining',
          data: this.remaining,
          borderColor: '#F44336',
          backgroundColor: '#F44336',
          fill: false
        }, {
          label: 'Realized',
          data: this.realized,
          borderColor: '#FFC107',
          backgroundColor: '#FFC107',
          fill: false
        }]
      };
    }
  },
  components: { Burndown: __WEBPACK_IMPORTED_MODULE_0__Burndown__["a" /* default */], SprintDone: __WEBPACK_IMPORTED_MODULE_1__SprintDone___default.a, SprintScore: __WEBPACK_IMPORTED_MODULE_2__SprintScore___default.a, SprintName: __WEBPACK_IMPORTED_MODULE_3__SprintName___default.a, SprintForm: __WEBPACK_IMPORTED_MODULE_4__SprintForm___default.a, SprintList: __WEBPACK_IMPORTED_MODULE_5__SprintList___default.a }
});

/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_LinkTo__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_LinkTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_LinkTo__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sprints',
  data: function data() {
    return {
      history: this.$select('sprints')
    };
  },

  computed: {
    isEmpty: function isEmpty() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default()(this.history);
    }
  },
  methods: {
    deleteSprint: function deleteSprint(sprintId) {
      console.log(sprintId);
    }
  },
  components: { LinkTo: __WEBPACK_IMPORTED_MODULE_1__ui_LinkTo___default.a }
});

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'action-button',
  props: {
    block: {
      type: Boolean,
      value: false
    },
    medium: {
      type: Boolean,
      value: false
    }
  }
});

/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'link-to',
  props: {
    href: {
      type: String
    }
  }
});

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'text-input',
  watch: {
    value: function value(newValue) {
      this.email = newValue;
    }
  },
  data: function data() {
    return {
      email: this.value
    };
  },

  props: {
    name: {
      type: String,
      value: ''
    },
    placeholder: {
      type: String,
      value: ''
    },
    id: {
      type: String,
      value: ''
    },
    autofocus: {
      type: Boolean,
      value: false
    }
  }
});

/***/ }),

/***/ 355:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 356:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 357:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 358:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 360:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 361:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 362:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 363:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 364:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 365:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 366:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 132,
	"./af.js": 132,
	"./ar": 139,
	"./ar-dz": 133,
	"./ar-dz.js": 133,
	"./ar-kw": 134,
	"./ar-kw.js": 134,
	"./ar-ly": 135,
	"./ar-ly.js": 135,
	"./ar-ma": 136,
	"./ar-ma.js": 136,
	"./ar-sa": 137,
	"./ar-sa.js": 137,
	"./ar-tn": 138,
	"./ar-tn.js": 138,
	"./ar.js": 139,
	"./az": 140,
	"./az.js": 140,
	"./be": 141,
	"./be.js": 141,
	"./bg": 142,
	"./bg.js": 142,
	"./bn": 143,
	"./bn.js": 143,
	"./bo": 144,
	"./bo.js": 144,
	"./br": 145,
	"./br.js": 145,
	"./bs": 146,
	"./bs.js": 146,
	"./ca": 147,
	"./ca.js": 147,
	"./cs": 148,
	"./cs.js": 148,
	"./cv": 149,
	"./cv.js": 149,
	"./cy": 150,
	"./cy.js": 150,
	"./da": 151,
	"./da.js": 151,
	"./de": 154,
	"./de-at": 152,
	"./de-at.js": 152,
	"./de-ch": 153,
	"./de-ch.js": 153,
	"./de.js": 154,
	"./dv": 155,
	"./dv.js": 155,
	"./el": 156,
	"./el.js": 156,
	"./en-au": 157,
	"./en-au.js": 157,
	"./en-ca": 158,
	"./en-ca.js": 158,
	"./en-gb": 159,
	"./en-gb.js": 159,
	"./en-ie": 160,
	"./en-ie.js": 160,
	"./en-nz": 161,
	"./en-nz.js": 161,
	"./eo": 162,
	"./eo.js": 162,
	"./es": 164,
	"./es-do": 163,
	"./es-do.js": 163,
	"./es.js": 164,
	"./et": 165,
	"./et.js": 165,
	"./eu": 166,
	"./eu.js": 166,
	"./fa": 167,
	"./fa.js": 167,
	"./fi": 168,
	"./fi.js": 168,
	"./fo": 169,
	"./fo.js": 169,
	"./fr": 172,
	"./fr-ca": 170,
	"./fr-ca.js": 170,
	"./fr-ch": 171,
	"./fr-ch.js": 171,
	"./fr.js": 172,
	"./fy": 173,
	"./fy.js": 173,
	"./gd": 174,
	"./gd.js": 174,
	"./gl": 175,
	"./gl.js": 175,
	"./gom-latn": 176,
	"./gom-latn.js": 176,
	"./he": 177,
	"./he.js": 177,
	"./hi": 178,
	"./hi.js": 178,
	"./hr": 179,
	"./hr.js": 179,
	"./hu": 180,
	"./hu.js": 180,
	"./hy-am": 181,
	"./hy-am.js": 181,
	"./id": 182,
	"./id.js": 182,
	"./is": 183,
	"./is.js": 183,
	"./it": 184,
	"./it.js": 184,
	"./ja": 185,
	"./ja.js": 185,
	"./jv": 186,
	"./jv.js": 186,
	"./ka": 187,
	"./ka.js": 187,
	"./kk": 188,
	"./kk.js": 188,
	"./km": 189,
	"./km.js": 189,
	"./kn": 190,
	"./kn.js": 190,
	"./ko": 191,
	"./ko.js": 191,
	"./ky": 192,
	"./ky.js": 192,
	"./lb": 193,
	"./lb.js": 193,
	"./lo": 194,
	"./lo.js": 194,
	"./lt": 195,
	"./lt.js": 195,
	"./lv": 196,
	"./lv.js": 196,
	"./me": 197,
	"./me.js": 197,
	"./mi": 198,
	"./mi.js": 198,
	"./mk": 199,
	"./mk.js": 199,
	"./ml": 200,
	"./ml.js": 200,
	"./mr": 201,
	"./mr.js": 201,
	"./ms": 203,
	"./ms-my": 202,
	"./ms-my.js": 202,
	"./ms.js": 203,
	"./my": 204,
	"./my.js": 204,
	"./nb": 205,
	"./nb.js": 205,
	"./ne": 206,
	"./ne.js": 206,
	"./nl": 208,
	"./nl-be": 207,
	"./nl-be.js": 207,
	"./nl.js": 208,
	"./nn": 209,
	"./nn.js": 209,
	"./pa-in": 210,
	"./pa-in.js": 210,
	"./pl": 211,
	"./pl.js": 211,
	"./pt": 213,
	"./pt-br": 212,
	"./pt-br.js": 212,
	"./pt.js": 213,
	"./ro": 214,
	"./ro.js": 214,
	"./ru": 215,
	"./ru.js": 215,
	"./sd": 216,
	"./sd.js": 216,
	"./se": 217,
	"./se.js": 217,
	"./si": 218,
	"./si.js": 218,
	"./sk": 219,
	"./sk.js": 219,
	"./sl": 220,
	"./sl.js": 220,
	"./sq": 221,
	"./sq.js": 221,
	"./sr": 223,
	"./sr-cyrl": 222,
	"./sr-cyrl.js": 222,
	"./sr.js": 223,
	"./ss": 224,
	"./ss.js": 224,
	"./sv": 225,
	"./sv.js": 225,
	"./sw": 226,
	"./sw.js": 226,
	"./ta": 227,
	"./ta.js": 227,
	"./te": 228,
	"./te.js": 228,
	"./tet": 229,
	"./tet.js": 229,
	"./th": 230,
	"./th.js": 230,
	"./tl-ph": 231,
	"./tl-ph.js": 231,
	"./tlh": 232,
	"./tlh.js": 232,
	"./tr": 233,
	"./tr.js": 233,
	"./tzl": 234,
	"./tzl.js": 234,
	"./tzm": 236,
	"./tzm-latn": 235,
	"./tzm-latn.js": 235,
	"./tzm.js": 236,
	"./uk": 237,
	"./uk.js": 237,
	"./ur": 238,
	"./ur.js": 238,
	"./uz": 240,
	"./uz-latn": 239,
	"./uz-latn.js": 239,
	"./uz.js": 240,
	"./vi": 241,
	"./vi.js": 241,
	"./x-pseudo": 242,
	"./x-pseudo.js": 242,
	"./yo": 243,
	"./yo.js": 243,
	"./zh-cn": 244,
	"./zh-cn.js": 244,
	"./zh-hk": 245,
	"./zh-hk.js": 245,
	"./zh-tw": 246,
	"./zh-tw.js": 246
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 508;

/***/ }),

/***/ 530:
/***/ (function(module, exports) {

module.exports = {
	"name": "vue-chartjs",
	"version": "2.6.3",
	"description": "vue.js wrapper for chart.js",
	"author": "Jakub Juszczak <jakub@posteo.de>",
	"homepage": "http://vue-chartjs.org",
	"license": "MIT",
	"contributors": [
		{
			"name": "Thorsten Lünborg",
			"web": "https://github.com/LinusBorg"
		},
		{
			"name": "Juan Carlos Alonso",
			"web": "https://github.com/jcalonso"
		}
	],
	"maintainers": [
		{
			"name": "Jakub Juszczak",
			"email": "jakub@posteo.de",
			"web": "http://www.jakubjuszczak.de"
		}
	],
	"repository": {
		"type": "git",
		"url": "git+ssh://git@github.com:apertureless/vue-chartjs.git"
	},
	"bugs": {
		"url": "https://github.com/apertureless/vue-chartjs/issues"
	},
	"keywords": [
		"ChartJs",
		"Vue",
		"Visualisation",
		"Wrapper",
		"Charts"
	],
	"main": "dist/vue-chartjs.js",
	"unpkg": "dist/vue-chartjs.full.min.js",
	"module": "es/index.js",
	"jsnext:main": "es/index.js",
	"files": [
		"src",
		"dist",
		"es"
	],
	"scripts": {
		"dev": "node build/dev-server.js",
		"build": "yarn run release && yarn run build:es",
		"build:es": "cross-env BABEL_ENV=es babel src --out-dir es",
		"unit": "karma start test/unit/karma.conf.js --single-run",
		"e2e": "node test/e2e/runner.js",
		"test": "npm run unit",
		"lint": "eslint --ext .js,.vue src test/unit/specs test/e2e/specs",
		"release": "webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js",
		"prepublish": "yarn run lint && yarn run test && yarn run build"
	},
	"dependencies": {
		"lodash": "^4.17.4"
	},
	"peerDependencies": {
		"chart.js": "^2.5.0",
		"vue": "^2.3.3"
	},
	"devDependencies": {
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-loader": "^7.0.0",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"babel-runtime": "^6.23.0",
		"chai": "^3.5.0",
		"chart.js": "^2.5.0",
		"chromedriver": "^2.28.0",
		"connect-history-api-fallback": "^1.1.0",
		"cross-env": "^3.2.4",
		"cross-spawn": "^5.1.0",
		"css-loader": "^0.28.0",
		"eslint": "^3.19.0",
		"eslint-config-standard": "^10.2.1",
		"eslint-friendly-formatter": "^2.0.7",
		"eslint-loader": "^1.7.1",
		"eslint-plugin-html": "^2.0.1",
		"eslint-plugin-import": "^2.2.0",
		"eslint-plugin-node": "^4.2.2",
		"eslint-plugin-promise": "^3.5.0",
		"eslint-plugin-standard": "^3.0.1",
		"eventsource-polyfill": "^0.9.6",
		"express": "^4.15.2",
		"extract-text-webpack-plugin": "^1.0.1",
		"file-loader": "^0.10.1",
		"function-bind": "^1.0.2",
		"html-webpack-plugin": "^2.28.0",
		"http-proxy-middleware": "^0.17.4",
		"inject-loader": "^3.0.0",
		"isparta-loader": "^2.0.0",
		"jasmine-core": "^2.5.2",
		"json-loader": "^0.5.4",
		"karma": "^1.5.0",
		"karma-coverage": "^1.1.1",
		"karma-jasmine": "^1.0.2",
		"karma-mocha": "^1.2.0",
		"karma-phantomjs-launcher": "^1.0.4",
		"karma-sinon-chai": "^1.2.0",
		"karma-sourcemap-loader": "^0.3.7",
		"karma-spec-reporter": "0.0.30",
		"karma-webpack": "1.8.1",
		"lolex": "^1.6.0",
		"mocha": "^3.1.0",
		"nightwatch": "^0.9.14",
		"ora": "^1.2.0",
		"phantomjs-prebuilt": "^2.1.13",
		"selenium-server": "^3.3.1",
		"shelljs": "^0.7.7",
		"sinon": "^2.1.0",
		"sinon-chai": "^2.9.0",
		"url-loader": "^0.5.8",
		"vue": "^2.3.3",
		"vue-hot-reload-api": "^2.1.0",
		"vue-html-loader": "^1.2.4",
		"vue-loader": "^12.0.4",
		"vue-style-loader": "^3.0.1",
		"vue-template-compiler": "^2.3.3",
		"webpack": "^1.13.2",
		"webpack-dev-middleware": "^1.10.1",
		"webpack-hot-middleware": "^2.17.1",
		"webpack-merge": "1.1.1"
	},
	"engines": {
		"node": ">=6.9.0"
	},
	"babel": {
		"presets": [
			"es2015"
		]
	},
	"browserify": {
		"transform": [
			"babelify"
		]
	},
	"greenkeeper": {
		"ignore": [
			"extract-text-webpack-plugin",
			"karma-webpack",
			"webpack",
			"webpack-merge"
		]
	}
};

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(360)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(545),
  /* scopeId */
  "data-v-4b68be32",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(356)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(541),
  /* scopeId */
  "data-v-0a35c0a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(361)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(546),
  /* scopeId */
  "data-v-5c28d020",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(355)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(540),
  /* scopeId */
  "data-v-05e4beca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(358)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(543),
  /* scopeId */
  "data-v-2364ca37",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(366)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(551),
  /* scopeId */
  "data-v-fda25fd4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(364)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(549),
  /* scopeId */
  "data-v-cdfc7820",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(365)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(550),
  /* scopeId */
  "data-v-f21218d4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(357)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(542),
  /* scopeId */
  "data-v-22c9e8e0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 540:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    attrs: {
      "id": "table"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.realized), function(points, index) {
    return _c('tr', [_c('td', [_vm._v("\n        " + _vm._s(("Day " + (index + 1))) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n        " + _vm._s(points) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n        " + _vm._s(_vm.remaining[index]) + "\n      ")])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Day")]), _vm._v(" "), _c('th', [_vm._v("Realized")]), _vm._v(" "), _c('th', [_vm._v("Remaining")])])])
}]}

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "done",
    style: ({
      display: _vm.isDone ? 'block' : 'none'
    })
  }, [_c('h2', [_vm._v("Your sprint is done!")]), _vm._v(" "), _c('p', [_vm._v("What do you want to do next?")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('action-button', {
    attrs: {
      "block": "",
      "medium": ""
    },
    on: {
      "click": _vm.newSprint
    }
  }, [_vm._v("Create another sprint")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('action-button', {
    attrs: {
      "block": "",
      "medium": ""
    },
    on: {
      "click": _vm.showStats
    }
  }, [_vm._v("Show me some stats")])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: {
      'action-button': true, 'block': _vm.block, 'medium': _vm.medium
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 543:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('text-input', {
    attrs: {
      "id": "name",
      "placeholder": "Sprint name"
    },
    on: {
      "input": _vm.nameChanged
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "form"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(250)
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Burn it Down")]), _vm._v(" "), _c('p', [_vm._v("Track your daily burnt points.")]), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.submitData
    }
  }, [_c('div', {
    staticClass: "inputs"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "days"
    }
  }, [_vm._v("Days in Sprint")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.days),
      expression: "days"
    }],
    attrs: {
      "name": "days",
      "placeholder": "e.g 10",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.days)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.days = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "points"
    }
  }, [_vm._v("Planned points")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.points),
      expression: "points"
    }],
    attrs: {
      "name": "points",
      "placeholder": "e.g 50"
    },
    domProps: {
      "value": (_vm.points)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.points = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.days || !_vm.points,
      "type": "submit"
    }
  }, [_vm._v("Go!")])])]), _vm._v(" "), _c('link-to', {
    attrs: {
      "href": "#/sprints"
    }
  }, [_vm._v("Show completed sprints")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 546:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "id": "form"
    },
    on: {
      "submit": _vm.submitData
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.day),
      expression: "day"
    }],
    attrs: {
      "name": "day"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.day = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": -1
    }
  }, [_vm._v("Select a day...")]), _vm._v(" "), _vm._l((_vm.days), function(day) {
    return _c('option', {
      domProps: {
        "value": day
      }
    }, [_vm._v("\n      " + _vm._s(("Day " + (day + 1))) + "\n    ")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.points),
      expression: "points"
    }],
    attrs: {
      "name": "points",
      "placeholder": "Points spent...",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.points)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.points = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Set")])])
},staticRenderFns: []}

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "id": _vm.id,
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "autofocus": _vm.autofocus
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "change": function($event) {
        _vm.$emit('change')
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, function($event) {
        _vm.$emit('input', _vm.email)
      }]
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "history"
  }, [_c('a', {
    attrs: {
      "href": _vm.href
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [_c('div', {
    staticClass: "data"
  }, [_c('sprint-done'), _vm._v(" "), _c('sprint-score'), _vm._v(" "), _c('sprint-name'), _vm._v(" "), _c('sprint-form'), _vm._v(" "), _c('sprint-list')], 1), _vm._v(" "), _c('div', {
    staticClass: "burndown"
  }, [_c('burndown', {
    attrs: {
      "chartData": _vm.chartData
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "form"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(250)
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Burn it Down")]), _vm._v(" "), _c('p', [_vm._v("Track your daily burnt points.")]), _vm._v(" "), _c('h3', [_vm._v("History")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [(_vm.isEmpty) ? _c('p', {
    staticClass: "empty"
  }, [_vm._v("No sprints to show.")]) : _vm._e(), _vm._v(" "), (!_vm.isEmpty) ? _c('table', [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.history), function(sprint) {
    return _c('tr', [_c('td', {
      staticClass: "col-left"
    }, [_vm._v(_vm._s(sprint.id))]), _vm._v(" "), _c('td', {
      staticClass: "col-left"
    }, [_vm._v(_vm._s(sprint.name))]), _vm._v(" "), _c('td', {
      staticClass: "col-right"
    }, [_vm._v(_vm._s(sprint.days))]), _vm._v(" "), _c('td', {
      staticClass: "col-right"
    }, [_vm._v(_vm._s(sprint.points))]), _vm._v(" "), _c('td', {
      staticClass: "col-right"
    }, [_vm._v(_vm._s(sprint.pointsPerDay.toFixed(2)))]), _vm._v(" "), _c('td', [_c('link-to', {
      attrs: {
        "href": ("#/sprint/" + (sprint.id))
      }
    }, [_vm._v("View")])], 1), _vm._v(" "), _c('td', [_c('link-to', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v("Stats")])], 1), _vm._v(" "), _c('td', [_c('link-to', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.deleteSprint.bind(this, sprint.id)
        }
      }
    }, [_vm._v("Delete")])], 1)])
  }))]) : _vm._e()]), _vm._v(" "), _c('link-to', {
    attrs: {
      "href": "#/"
    }
  }, [_vm._v("Go back")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col-left"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "col-left"
  }, [_vm._v("Sprint Name")]), _vm._v(" "), _c('th', {
    staticClass: "col-right"
  }, [_vm._v("Days")]), _vm._v(" "), _c('th', {
    staticClass: "col-right"
  }, [_vm._v("Points")]), _vm._v(" "), _c('th', {
    staticClass: "col-right"
  }, [_vm._v("Points per Day")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
}]}

/***/ }),

/***/ 551:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "score"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('span', {
    attrs: {
      "title": ""
    }
  }, [_vm._v("Score")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.score ? _vm.score.toFixed(2) : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('span', {
    attrs: {
      "title": ""
    }
  }, [_vm._v("Health")]), _vm._v(" "), _c('div', {
    class: ['health', _vm.health]
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('span', {
    attrs: {
      "title": ""
    }
  }, [_vm._v("Points per Day")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.pointsPerDay ? _vm.pointsPerDay.toFixed(2) : 0))])])])
},staticRenderFns: []}

/***/ })

},[256]);


// WEBPACK FOOTER //
// static/js/app.8eb1187de2fb19752859.js